import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field, change, untouch} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {
    NumberInput,
    minValue
} from 'admin-on-rest';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';
import NewTransferProductUnitTableRow from '../components/NewTransferProductUnitTableRow';
import FuseTheme from '../global/theme';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentCheck from 'material-ui/svg-icons/action/check-circle';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";

/**
 * A component for generating rows of NewTransferProductUnitTableRows for new Transfers
 * It retrieves Product Units by Product Type and Case, and adds or deletes them from the transfer list.
 *
 */
class NewTransferProductUnitTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayUpdateMessage: false,
            itemChoices: [],
            itemUpdated: false,
            itemUpdateMessage: null,
            showForm: false,
            itemBarcodeValue: null,
            itemQtyValue: 1,
            transferItems: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCreateNewItem = this.handleCreateNewItem.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
    }

    componentWillMount() {
        if (this.props.productType) {
            this.fetchData();
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidUpdate(prevProps) {
        if (this.props.productType && (this.props.productType !== prevProps.productType)) {
            this.fetchData();
            this.props.dispatch(change('record-form', 'item_select_field', ''));
            this.props.dispatch(untouch('record-form', 'item_select_field'));
            this.props.dispatch(change('record-form', 'item_qty_field', 1));
            this.props.dispatch(untouch('record-form', 'item_qty_field'));
        }
    }

    // Get Product Units for adding Cases
    fetchData() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"},
            type: this.props.productType,
            unit_type: 'Case'
        };
        const resource = productResources.ProductUnitsByTypeUnitType.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.processChoices(result.data.payload);
                        this.setState({
                            itemChoices: choices
                        });
                    }
                }).catch((error) => {
                    let message = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                        if (error.response.data.error_message) {
                            message = error.response.data.error_message;
                            console.log('Error: ' + message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    /**
     * Filter Product Unit choices
     *
     * @param choices
     * @return array
     */
    processChoices(choices) {
        // Format the display name of the results
        for (let choice of choices) {
            const id = choice.id;
            const name = (choice.name) ? ' - ' + choice.name : '';
            const brand = (choice.brand) ? ' (' + choice.brand + ')' : '';
            choice.name = id + name + brand;
            choice.transfer_type = 'product_unit';
        }
        return choices;
    }

    handleInputChange(event, index) {
        this.setState({
            displayUpdateMessage: false,
            itemUpdated: false,
            itemUpdateMessage: null
        });
    }

    // Handle event to display form and table
    handleFormDisplay = () => {
        this.setState({
            showForm: true
        });
    };

    // Create a new item based on field values
    handleCreateNewItem = (e) => {

        const barcode = this.props.itemBarcodeValue;
        const qty = this.props.itemQtyValue;
        if (!barcode || !qty) {
            return;
        }

        let transferItems = this.props.transferItems;
        let displayUpdateMessage = false;
        let itemUpdated = false;
        let itemUpdateMessage = null;

        // Determine if item already exists in list
        let existingItem = transferItems.find(item => item.barcode.toString() === barcode.toString());
        if (existingItem) {
            if (existingItem.qty === qty) {
                // No update to existing item
                displayUpdateMessage = true;
                itemUpdateMessage = 'This item with this Quantity is already in the Transfer list. No update was made.';
            } else {
                // Update the existing item's quantity
                existingItem.qty = qty;
                itemUpdated = true;
                displayUpdateMessage = true;
                itemUpdateMessage = 'This item is already in the Transfer list. Its Quantity has been updated with the new amount.';
            }
        } else {
            // Add the new item
            transferItems.push({barcode: barcode, qty: qty, transfer_type: 'product_unit'});
            itemUpdated = true;
            displayUpdateMessage = true;
            itemUpdateMessage = 'Added item to the Transfer list.';
        }

        // Dispatch events
        if (itemUpdated) {
            this.props.onAddUpdate({transferItems: transferItems});
            this.props.dispatch(change('record-form', 'transfer_items', transferItems));
        }

        // Reset fields and update state
        this.props.dispatch(change('record-form', 'item_select_field', ''));
        this.props.dispatch(untouch('record-form', 'item_select_field'));
        this.props.dispatch(change('record-form', 'item_qty_field', 1));
        this.props.dispatch(untouch('record-form', 'item_qty_field'));
        this.setState({
            itemBarcodeValue: null,
            displayUpdateMessage: displayUpdateMessage,
            itemUpdateMessage: itemUpdateMessage,
            itemQtyValue: null,
            transferItems: transferItems
        });

    };

    // Handle event from item Delete icon
    handleDeleteItem = (item) => {
        let transferItems = this.props.transferItems;
        let idx = transferItems.findIndex(listItem => listItem.barcode === item.barcode);
        if (idx !== -1) {
            // Remove the item if it exists
            transferItems.splice(idx, 1);

            this.props.onDeleteUpdate({transferItems: transferItems});
            this.props.dispatch(change('record-form', 'transfer_items', transferItems));

            this.setState({
                displayUpdateMessage: true,
                itemUpdateMessage: 'Removed ' + item.barcode.toString() + ' from Transfer list.',
                transferItems: transferItems
            });
        }
    };

    // Create rows of added items
    makeItemTable = (list, deleteClickFunc) => {
        const styles = {
            row: {height: '40px'},
        };
        if (!list || list.length === 0 || !list.length) {
            return (
                <TableRow style={styles.row}>
                    <TableRowColumn colSpan={2} style={styles.row}>No Items</TableRowColumn>
                    <TableRowColumn style={styles.row}>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        // Display Collection items only of this type
        const collectionList = [];
        for (let item of list) {
            if (item.transfer_type && item.transfer_type === 'product_unit') {
                collectionList.push(item);
            }
        }
        return (
            collectionList.map((item, index) => (
                <NewTransferProductUnitTableRow
                    key={item.barcode.toString() + index}
                    data={item}
                    onDeleteClick={deleteClickFunc}
                />
            ))
        )
    };

    render() {
        const {
            itemBarcodeValue,
            itemQtyValue,
            productType
        } = this.props;
        const styles = {
            addBlock: {padding: '8px 0 0 16px'},
            alignBottom: {verticalAlign: 'bottom'},
            alignTop: {verticalAlign: 'top'},
            block: {display: 'block'},
            button: {display: 'inline-block', margin: '0 0 0 1em'},
            error: {
                display: 'block',
                width: 'auto',
                fontSize: '12px',
                color: FuseTheme.palette.accent1Color,
            },
            fieldHeader: {
                display: 'block',
                width: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
                color: FuseTheme.palette.textColor,
                margin: '1em 0 0 0',
            },
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            fieldSmall: {display: 'inline-block', maxWidth: 100},
            icon: {display: 'inline-block', fontSize: 16, marginRight: 4, verticalAlign: 'sub'},
            iconCheck: {color: FuseTheme.palette.accent3Color},
            marginTop: {margin: '1em 0 0 0'},
            rowHeight: {height: '40px'},
            tableCard: {display: 'block', margin: '1em 0 0 0'},
            visuallyHidden: {},
        };
        return (
            <div>
                {!productType &&
                <div style={styles.marginTop}>
                    <span style={styles.fieldDescription}>
                        You must select Locations before adding Transfer content.
                    </span>
                </div>
                }
                {!this.state.showForm && productType &&
                <div style={styles.marginTop}>
                    <RaisedButton
                        primary
                        label="Add Product Unit Cases"
                        icon={<ContentAdd/>}
                        onClick={(e) => this.handleFormDisplay(e)}
                    />
                </div>
                }
                {this.state.showForm && productType &&
                <div style={styles.marginTop}>
                    <Card style={styles.tableCard}>
                        <CardHeader title="Product Unit Cases"/>
                        <CardText>
                            {/* Instructions */}
                            <span style={styles.fieldDescription}>
                                Below are Product Unit Cases of the selected Product Type. Select a Product Unit Case
                                from the list and set a Quantity. Click <strong>Add Selected Item</strong> to add it
                                to the Transfer list.
                                <br/><br/>
                                To remove a Product Unit Case from the list, click its Delete icon.
                            </span>
                            <div>
                                {/* Item Selection, Quantity Fields, Add Button */}
                                <Field name="item_select_field"
                                       component={VirtualizedSelectInput}
                                       choices={this.state.itemChoices}
                                       label="Product Units"
                                       optionText="name"
                                       defaultValue={itemBarcodeValue}
                                       allowEmpty
                                       onChange={this.handleInputChange}
                                       options={{
                                           className: "full-width",
                                           labelKey: "name",
                                           placeholder: "Product Units",
                                       }}
                                />
                                <Field name="item_qty_field"
                                       label="Quantity"
                                       component={NumberInput}
                                       step={1}
                                       value={1}
                                       onChange={this.handleInputChange}
                                       validate={[minValue(1, 'Must be at least 1.')]}
                                       elStyle={styles.fieldSmall}
                                       defaultValue={this.state.itemQtyValue}
                                />
                                <FlatButton
                                    primary
                                    label="Add Selected Item"
                                    icon={<ContentAdd/>}
                                    onClick={(e) => this.handleCreateNewItem(e)}
                                    disabled={!itemBarcodeValue || !itemQtyValue}
                                    style={styles.button}
                                />
                                {this.state.displayUpdateMessage &&
                                <span style={styles.fieldDescription}>
                                    {/* Messaging */}
                                    <ContentCheck style={{...styles.icon, ...styles.iconCheck}}/>
                                    {this.state.itemUpdateMessage}
                                </span>
                                }
                            </div>

                            {/* Table: Selected Transfer Items */}
                            <span style={styles.fieldHeader}>
                                Product Unit Cases in Transfer List
                            </span>
                            <Table selectable={false} multiSelectable={false}>
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                        <TableHeaderColumn>Barcode</TableHeaderColumn>
                                        <TableHeaderColumn>Quantity</TableHeaderColumn>
                                        <TableHeaderColumn>&nbsp;</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {[...this.makeItemTable(this.props.transferItems, this.handleDeleteItem)]}
                                </TableBody>
                            </Table>
                        </CardText>
                    </Card>
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const selectValue = (form.values['item_select_field']) ? form.values['item_select_field'].toString() : null;
        const qtyValue = (form.values['item_qty_field']) ? parseInt(form.values['item_qty_field'], 10) : 1;
        const dba = (form.values['location_from_dba']) ? (form.values['location_from_dba']) : null;
        const productTypeValue = (dba && dba.product_type) ? dba.product_type.toString() : null;
        const transferItems = (form.values['transfer_items']) ? form.values['transfer_items'] : [];
        return {
            itemBarcodeValue: selectValue,
            itemQtyValue: qtyValue,
            productType: productTypeValue,
            transferItems: transferItems
        }
    }
    return {
        itemBarcodeValue: null,
        itemQtyValue: 1,
        productType: null,
        transferItems: []
    }
};

NewTransferProductUnitTable.propTypes = {
    addField: PropTypes.bool,
    itemBarcodeValue: PropTypes.string,
    itemQtyValue: PropTypes.number,
    onAddUpdate: PropTypes.func,
    onDeleteUpdate: PropTypes.func,
    productType: PropTypes.string,
    showCreate: PropTypes.bool,
    transferItems: PropTypes.array,
};

NewTransferProductUnitTable.defaultProps = {
    addField: true,
    transferItems: [],
    itemBarcodeValue: null,
    itemQtyValue: 1,
    showCreate: false,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(NewTransferProductUnitTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/NewTransferProductUnitTable.js